export const GET_POSTS = 'GET_POSTS';
export const GET_POSTS_SUCCESS = 'GET_POSTS_SUCCESS';
export const GET_POSTS_FAIL = 'GET_POSTS_FAIL';

export const GET_POST_DETAILS = 'GET_POST_DETAILS';
export const GET_POST_DETAILS_SUCCESS = 'GET_POST_DETAILS_SUCCESS';
export const GET_POST_DETAILS_FAIL = 'GET_POST_DETAILS_FAIL';
